import { faSave } from '@fortawesome/free-regular-svg-icons'

import Icon from './common-parts/Icon'

export default function SaveIcon(props) {
  return (
      <Icon
        size="2x"
        {...props}
        icon={faSave}
      />
  );
}
